import Mutations from '../../odata/mutations';

export default { ...new Mutations('cartonSymbol'), ...new Mutations('cartonSymbols') };
